import { usePanelStore, type PanelView } from "../../state/panel";
import styles from "./IconStrip.module.css";

type IconEntry =
  | {
      kind: "tab";
      id: PanelView;
      glyph: string;
      label: string;
    }
  | {
      kind: "shortcut";
      id: string;
      glyph: string;
      label: string;
      matchView: PanelView;
      matchFocusKind: string;
      onActivate: () => void;
    };

export function IconStrip() {
  const view = usePanelStore((s) => s.view);
  const focus = usePanelStore((s) => s.focus);
  const setView = usePanelStore((s) => s.setView);
  const reveal = usePanelStore((s) => s.reveal);

  const icons: IconEntry[] = [
    { kind: "tab", id: "intelligence", glyph: "◈", label: "intelligence" },
    {
      kind: "shortcut",
      id: "cohort",
      glyph: "▦",
      label: "portfolio cohort",
      matchView: "intelligence",
      matchFocusKind: "cohort",
      onActivate: () => reveal("intelligence", { kind: "cohort" }),
    },
    { kind: "tab", id: "transactions", glyph: "≋", label: "transactions" },
    { kind: "tab", id: "settings", glyph: "◎", label: "settings" },
  ];

  return (
    <nav className={styles.strip} aria-label="panel tabs">
      {icons.map((icon) => {
        const active =
          icon.kind === "tab"
            ? icon.id === view
            : view === icon.matchView && focus.kind === icon.matchFocusKind;
        return (
          <button
            key={icon.id}
            type="button"
            className={`${styles.icon} ${active ? styles.active : ""}`}
            aria-label={icon.label}
            title={icon.label}
            onClick={() => (icon.kind === "tab" ? setView(icon.id) : icon.onActivate())}
          >
            {icon.glyph}
          </button>
        );
      })}
    </nav>
  );
}
